import { Outlet, Link, useLocation, Form } from 'react-router-dom';
import { useEffect } from 'react';

import {wpUser} from '../../../k';

export default function SiteError() {
  const location = useLocation();
  useEffect(() => {
    let y = window.localStorage.getItem('baUid');
    console.log({ y });
    if (y != null) {
      window.location.href = `${wpUser}/dashboard`;
    } else { 
      window.localStorage.clear();
      if (window.location.href.includes("account")) {
        
      }else{
        window.location.href = `${wpUser}`;
      }
      //causes redirection error
      //window.location.href = `${wpUser}`; 
    } 
  }, [location]);
  return (
    <div>
      {/*
      <p>An Error just occured</p>
    */}
    </div>
  );
}
